const PanelWrapper = ({children, props}) => {
    const style = props?.style ? props?.style : {};
    return <div className="p-4" style={{overflowY: 'scroll', height: '100%', ...style}}>{children}</div>;
}

export default PanelWrapper;
